module.exports = __webpack_public_path__ + "static/media/ic_general_punto_gris.ce8a93e9.svg";